<template>
    <div class="reset">
        <div class="page">
            <div class="row">
                <div class="col image">
                    <img src="../../assets/images/icon.png">
                </div>
            </div>
            <div class="row">
                <div class="col title">
                    <h1>Passwort vergessen?</h1>
                    <h3>Bitte gib deine Email Adresse ein, wir senden dir ein neues Passwort.</h3>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <form>
                        <label>Email:</label><br>
                        <input type="text" :value="email"><br>
                        <button>Neues Passwort anfordern</button><br>
                        <router-link to="/login" activeClass="active" tag="button" id="account">Zurücz zum Login</router-link>
                    </form>
                    <br>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '../Header';

    export default {
        name: 'app',
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                password_hint: 'Passwort',
                email: ''
            }
        },
        components: {
            appHeader: Header
        },
        created(){
            this.email=this.$route.params.email;
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/style';
    .reset {
        width: 100%;
        height: 100vh;
        background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.9)), url("../../assets/images/login_background.png");
        background-size: cover;
        background-position: center;
        color: $betuszin;

        .page {
            width: 90%;
            margin: auto;
            .image {
                margin-top: 70px;
                margin-left: 20px;
                img {

                }
            }
            .title{
                margin: 54px 45px 26px 19px;
                h1 {
                    font-size: 2.0rem;
                    font-weight: 700;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 36px;
                    margin-bottom:2px;
                }
                h3{
                    font-size: 1.6rem;
                    font-family: "SF UI Text Light";
                    font-weight: 400;
                    font-style: normal;
                    font-stretch: normal;
                    line-height: 20px;
                }
            }
            form{
                width:90%;
                margin: auto;
                label{
                    font-size:1.2rem;
                    text-transform: uppercase;
                    font-weight: 200;
                }
                input{
                    margin-top: 0px;
                    padding:3px 5px;
                    width:100%;
                    background: transparent;
                    border: none;
                    border-bottom:1px $betuszin solid;
                    color: $betuszin;
                    font-size:1.7rem;
                }
                button {
                    color: $betuszin;
                    font-size: 1.5rem;
                    font-weight: 600;
                    font-family: "SF UI Text Light";
                    display: block;
                    margin: 141px auto 20px auto;
                    width: 98%;
                    display: block;
                    background-color: $lila;
                    padding: 13px 0;
                    border-radius: 5px;
                    border: none;
                }
                #account{
                    background-color: transparent;
                    margin-top:2px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/resetPassword/Reset.vue